module.exports = __webpack_public_path__ + "static/img/preferences.161625f1.svg";